import Layout from "./Layout";
import { useTranslation } from "react-i18next";

const ChangePassword = ({ isUserRole, openModal } : { isUserRole: boolean, openModal: () => void }) => {
    const { t } = useTranslation();

    return <Layout variant="ghost" parentClass='no-child' title={t(isUserRole ? `auth.login.inputs.password` : `profile.changePassword.title`)} description={t(isUserRole ? `profile.changePassword.userDescription` : `profile.changePassword.description`)} btnText={t(`user.editUser.tabs.changePassword`)} handleNext={openModal}>{null}</Layout>
}

export default ChangePassword;